<template>
    <v-container>
        <v-card>
            <v-card-title class="justify-center primary" icon @click="mostrar()" style="cursor: pointer;">
                <v-toolbar-title id="titulocard">Documentos</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon :color="'#FFFFFF'">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-card-title>
            <v-expand-transition>
                <div v-if="show">
                    <v-card-text style="margin-bottom: 4%;" v-if="compartirTabla == false">
                        <v-row class="mt-1 d-flex justify-center">
                            <v-col cols="12" md="3" sm="4" class="d-flex justify-center"
                                v-if="adjuntarArchivos == 1 || adjuntarArchivos == 2">
                                <v-btn @click="AdjuntarDoc" color="#1565C0" class="white--text" block small>
                                    <v-icon left>mdi-plus</v-icon>
                                    Agregar Documento
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="3" sm="4" class="d-flex justify-center"
                                v-if="this.aiclave != 26 && mostarBoton > 0">
                                <v-btn @click="DocumentosNC" color="#1565C0" class="white--text" block small>
                                    Documentos no conformes
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="2" sm="4" class="d-flex justify-center">
                                <v-btn @click="DescargaMasivaZIP()" color="#1565C0" class="white--text" block small>
                                    <v-icon left>mdi-folder-download</v-icon>
                                    Descargar Expediente
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="2" sm="4" class="d-flex justify-center">
                                <v-btn @click="GenerarPDF()" color="#1565C0" class="white--text" block small>
                                    <v-icon left>mdi-file-pdf</v-icon>
                                    Generar PDF
                                </v-btn>
                            </v-col>

                            <v-col cols="12" md="2" sm="4" class="d-flex justify-center"
                                v-if="permisoCompartir && this.aiclave != 26">
                                <v-btn @click="CompartirAlerta()" color="#1565C0" class="white--text" block small>
                                    <v-icon left>mdi-share-variant</v-icon>
                                    Compartir
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="mt-1">
                            <v-col>
                                <DataTable class="tablaDocs" :url="urlListado" :columns="columns"
                                    :formatterActions="formatterActions" :params="displayInputs" :order="[]"
                                    @apiDT="apiDT = $event" @Cancelar="CancelarShow">
                                </DataTable>
                            </v-col>
                        </v-row>
                        <div v-show="showLightbox">
                            <LightBox ref="lightbox" :media="media" :show-caption="true" :show-light-box="false"
                                @onClosed="CerrarVisor()" />
                        </div>
                        <v-overlay :value="overlay">
                            <v-progress-circular indeterminate size="64"></v-progress-circular>
                        </v-overlay>
                    </v-card-text>
                    <v-card-text v-else>
                        <v-row class="mt-1">
                            <v-col cols="12" md="6" style="display: grid; place-items: center;">
                                <v-btn color="error" style="color:white" @click="CancelarCompartir()">
                                    <v-icon left>
                                        mdi-close-circle
                                    </v-icon>
                                    Cancelar
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="6" style="display: grid; place-items: center;">
                                <v-btn @click="Compartir()" color="#1565C0" style="color:white"
                                    :disabled="disCompartir">
                                    <v-icon left>
                                        mdi-share-variant
                                    </v-icon>
                                    Compartir
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row style="display: grid; place-items: center;">
                            <DataTable class="tablaDocs" :url="urlListadoShare" :columns="columnsCompartir"
                                :formatterActions="formatterActions" :params="displayInputs" :order="[]"
                                @apiDT="apiDT = $event" @Cancelar="CancelarShow" select="multiple"
                                :reduce="fila => fila.docid" @input="seleccionarDocumentos" dom="'Bfrtip'"
                                @SeleccionTabla="SeleccionTablaTipo">
                            </DataTable>
                        </v-row>
                    </v-card-text>
                </div>
            </v-expand-transition>
        </v-card>
        <v-dialog v-model="share" scrollable persistent content-class="dialogShareClass"
            transition="dialog-bottom-transition">
            <template>
                <v-card>
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Compartir Documento</v-toolbar-title>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" col-md="8" class="text-center" style="display: grid; place-items: center;">
                                <span class="type-label-style">¿Desea compartir hasta que se concluya el
                                    reporte?:</span>
                                <div class="text-center">
                                    <v-radio-group :error-messages="errorRadio" v-model="respuesta" row>
                                        <v-radio label="SI" value="S"></v-radio>
                                        <v-radio label="NO" value="N"></v-radio>
                                    </v-radio-group>
                                </div>
                            </v-col>
                            <v-col cols="12" col-md="8" class="text-center" v-if="respuesta == 'N'">
                                <span class="files-report-label-style">Fecha:</span>
                                <v-dialog ref="dialogfh" outlined v-model="modalfh" :return-value.sync="selectedDate"
                                    persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="date-align-center">
                                            <v-text-field class="pt-2" v-model="selectedDate" label="" outlined dense
                                                v-bind="attrs" v-on="on" readonly>
                                            </v-text-field>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="selectedDate" :min="dateComponentConstraints.fechaMinima"
                                        locale="es" scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="secondary" @click="modalfh = false">Cancelar</v-btn>
                                        <v-btn text color="primary" @click="$refs.dialogfh.save(selectedDate)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" :disabled="buttonCompartir" @click="GuardarCompartir()"
                            :loading="buttonLoading">Guardar</v-btn>
                        <v-btn color="error" :disabled="buttonCompartir" variant="text"
                            @click="CerrarModal()">Cancelar</v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Archivos from '@/services/Archivos/Archivos.service.js';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import '@/components/pages/Visor/dist/vue-image-lightbox.min.css';
import LightBox from '@/components/pages/Visor/LightBox.vue';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
        LightBox
    },
    data: function () {
        return {
            cargando: false,
            show: false,
            verarchi: false,
            loading: false,
            docs: [],
            nombreArchivo: '',
            adjuntarArchivos: 0,
            contador: 1,
            paginas: 0,
            docid: 0,
            permisocalificar: false,
            aiclave: null,
            permisorestablecer: false,
            aiclave: null,
            svfhconclusion: '',
            mostarBoton: 0,

            ///////-----------------------------
            urlListado: 'Archivos/ObtenerDocumentos',
            urlListadoShare: 'Archivos/DocumentosACompartir',
            columns: [
                { name: 'Compartio', data: 'Compartio', title: '', formatter: [this, "Compartir_Archivo"], orderable: false },
                { name: 'doiniciales', data: 'doiniciales', title: 'Iniciales' },
                { name: 'dodescrip', data: 'dodescrip', title: 'Descripción' },
                { name: 'docalta', data: 'docalta', title: 'Fecha escaneo' },
                { name: 'prclave', data: 'prclave', title: 'Usuario' },
                { name: "docid", data: "docid", title: "", formatter: [this, "Ver_Archivo"], orderable: false },
                { name: "ddocid", data: "docid", title: "", formatter: [this, "Descargar_Archivo"], orderable: false },
                { name: "cdocid", data: "docid", title: "", formatter: [this, "EnviarCorreo"], orderable: false },
                { name: "cadocid", data: "docid", title: "", formatter: [this, "Calificar_Archivo"], orderable: false },
                { name: "rcdocid", data: "docid", title: "", formatter: [this, "Restablecer_Calificacion"], orderable: false },
                { name: "edocid", data: "docid", title: "", formatter: [this, "Eliminar_Archivo"], orderable: false },
                { name: "rcocid", data: "docid", title: "", formatter: [this, "Reclasificar_Archivo"], orderable: false },
                { name: "dociddiv", data: "docid", title: "", formatter: [this, "Dividir_Archivo"], orderable: false },
            ],
            displayInputs: {
                nrreporte: 0,
                svindice: 0,
                aiclave: 0
            },
            formatterActions: [
                { click: [this, "VerArchivo"] },
                { click: [this, "EliminarArchivo"] },
                { click: [this, "DescargarArchivo"] },
                { click: [this, "CalificarDoc"] },
                { click: [this, "RestablecerCalif"] },
                { click: [this, "Enviarcorreo"] },
                { click: [this, "Reclasificacion"] },
                { click: [this, "DividirPDF"] },
            ],
            apiDT: null,
            permisoEliminar: false,
            permisoennviarcorreo: false,
            isPDF: false,
            media: [{
                src: '@/',
                type: ''
            }],
            showLightbox: false,
            overlay: false,
            datos: null,
            /*comportir*/
            permisoCompartir: false,
            permisoReclasificar: false,
            documentos: [],
            disCompartir: true,
            share: false,
            buttonCompartir: false,
            modalfh: false,
            selectedDate: "",
            dateComponentConstraints: {},
            respuesta: null,
            errorRadio: '',
            buttonLoading: false,
            compartirTabla: false,
            columnsCompartir: [
                { name: 'Compartio', data: 'Compartio', title: '', formatter: [this, "Compartir_Archivo"], orderable: false },
                { name: 'doiniciales', data: 'doiniciales', title: 'Iniciales' },
                { name: 'dodescrip', data: 'dodescrip', title: 'Descripción' },
                { name: 'docalta', data: 'docalta', title: 'Fecha escaneo' },
                { name: 'prclave', data: 'prclave', title: 'Usuario' },
            ],
            statusConclusion: false,
            permisoDividirPDF: false
        }
    },
    props: [],
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        },
    },
    watch: {
        'documentos'(val) {
            this.disCompartir = val.length > 0 ? false : true
        },
        'respuesta'(val) {
            if (val != null) {
                this.errorRadio = '';
                if (val == 'N') {
                    let today = new Date().toJSON().slice(0, 10);
                    this.selectedDate = today;
                    this.dateComponentConstraints.fechaMinima = today;
                } else {
                    this.selectedDate = '';
                }
            }
        }
    },
    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        let valestatus = await MetodosGenerales.getReporteEstatus(this);
        this.statusConclusion = valestatus == 2 ? true : false;
        await this.obtenerPermisos();
        await Archivos.EstatusReporte(this, this.datos);
        this.displayInputs = {
            nrreporte: this.datos.nrreporte,
            svindice: this.datos.svindice,
            aiclave: this.datos.aiclave,
        };
        this.reloadTable();
    },
    async updated() {
        this.svfhconclusion = this.datos.svfhconclusion;
    },
    methods: {
        async Reclasificacion(params, datos, fila) {
            var datareporte = await MetodosGenerales.obtenerSessionReporte('reporte');

            var reporte = datareporte;

            const finalResult = Object.assign(reporte, datos);
            await MetodosGenerales.guardarEnSesionInfoReporte(finalResult, 'reporte');

            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
            this.$router.push({ path: asistenciaurl + '/Archivos/Reclasificacion' });
        },
        async CerrarVisor() {
            var img = {
                src: '@/',
                type: 'img'
            }
            this.media = [];
            this.media.push(img);
            this.showLightbox = false;
            await this.$refs.lightbox.showImage(0);
        },
        CancelarShow() {
            this.cargando = false;
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        Reclasificar_Archivo(datos) {
            if (datos.docestatus != 'C' && this.statusConclusion == false && this.permisoReclasificar == true)
                return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small teal dt-formatterAction" aria-haspopup="true" data-action="6" data-params="${datos.docid}" title="Reclasificar documento" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-cached theme--dark"></i></span></button></div>` : ``;
            else
                return ``;
        },
        Ver_Archivo(datos) {
            return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small teal dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos.docid}" title="Ver Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-file-eye theme--dark"></i></span></button></div>` : ``;
        },
        Eliminar_Archivo(datos) {
            if (this.permisoEliminar) {
                return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small secondary dt-formatterAction" aria-haspopup="true" data-action="1" data-params="${datos.docid}" title="Eliminar Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-delete theme--dark"></i></span></button></div>` : ``;
            } else {
                return ``;
            }
        },
        Descargar_Archivo(datos) {
            return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small info dt-formatterAction" aria-haspopup="true" data-action="2" data-params="${datos.docid}" title="Descargar Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-download-outline theme--dark"></i></span></button></div>` : ``;
        },
        Calificar_Archivo(datos) {
            if (this.permisocalificar) {
                return datos.docestatus != 'C' ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small light-blue dt-formatterAction" aria-haspopup="true" data-action="3" data-params="${datos.docid}" title="Calificar Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-file-star theme--dark"></i></span></button></div>` : ``;
            } else {
                return ``;
            }
        },
        Restablecer_Calificacion(datos) {
            if (this.permisorestablecer) {
                return datos.docestatus == 'C' ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small light-blue dt-formatterAction" aria-haspopup="true" data-action="4" data-params="${datos.docid}" title="Restablecer calificación" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-file-restore theme--dark"></i></span></button></div>` : ``;
            } else {
                return ``;
            }
        },
        Dividir_Archivo(datos) {
            if (this.permisoDividirPDF) {
                return datos.docestatus != 'C' ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small light-blue dt-formatterAction" aria-haspopup="true" data-action="7" data-params="${datos.docid}" title="Dividir archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi  mdi-file-pdf theme--dark"></i></span></button></div>` : ``;
            } else {
                return ``;
            }
        },
        EnviarCorreo(datos) {
            if (this.permisoennviarcorreo) {
                return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small primary dt-formatterAction" aria-haspopup="true" data-action="5" data-params="${datos.docid}" title="Enviar archivo por correo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-email-send theme--dark"></i></span></button></div>` : ``;
            } else {
                return ``;
            }
        },
        async DescargarArchivo(params, datos, fila) {
            this.$swal({
                title: 'Descargando archivo, espere, por favor.',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.$swal.showLoading();
                    var datosReporte = new FormData();
                    datosReporte.append("nrreporte", this.datos.nrreporte);
                    datosReporte.append("svindice", this.datos.svindice);
                    Archivos.DescargaZip(this.datos, datos.docid, datos.dodescrip).then(response => {
                        if (response != null) {
                            const url = window.URL.createObjectURL(new Blob([response]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', this.datos.nrreporte + '-' + this.datos.svindice + '-' + datos.dodescrip + '.zip');
                            document.body.appendChild(link);
                            link.click()
                            var formData = new FormData();
                            formData.append("lasitio", 'Prusia+');
                            formData.append("lomodulo", "Documentos");
                            formData.append("laaccion", "Descargó Documento .zip");
                            formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
                            formData.append("lanombre", this.datos.nrreporte + '-' + this.datos.svindice + '-' + this.datos.dodescrip + '.zip');
                            formData.append("ladestinatario", "");
                            Archivos.AlmacenarVisitas(formData).then(data => {
                            });

                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Correcto',
                                text: 'Archivo descargado correctamente',
                                showConfirmButton: true,
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Correcto',
                                text: 'Ocurrio un error, intentelo más tarde!!',
                                showConfirmButton: false,
                                timer: 2500
                            });
                        }
                    });
                },
            });
        },
        async VerArchivo(params, datos) {
            this.showLightbox = false;
            this.overlay = true;
            this.media = this.media.filter(obj => obj.src == '@/');
            this.isPDF = /\.pdf$/i.test(datos.docarchivo);
            let dir = await Archivos.ObtenerDireccion(this.datos, datos.docid, 1);
            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", 'Documentos');
            formData.append("laaccion", "Vio Documento");
            formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
            formData.append("lanombre", dir.archivo);
            formData.append("ladestinatario", "");

            await Archivos.AlmacenarVisitas(formData);
            if (dir.archivo !== null) {
                var img = {
                    src: dir.watch,
                    caption: '<h4>' + datos.dodescrip + '</h4>',
                    type: this.isPDF == true ? 'pdf' : 'img',
                    width: '800px',
                    docid: datos.docid,
                    paginas: datos.docpaginas,
                    archivo: dir.archivo
                };
                this.media.push(img);
                this.media = this.media.filter(obj => obj.src !== '@/');
                this.showLightbox = true;
            } else {
                var img = {
                    type: 'error',
                    caption: '<h4>' + datos.dodescrip + '</h4>',
                    docid: datos.docid,
                    paginas: datos.docpaginas
                };
                this.media.push(img);
                this.media = this.media.filter(obj => obj.src !== '@/');
                this.showLightbox = true;
            }
            this.overlay = false;
        },
        async Enviarcorreo(params, datosdoc, fila) {
            let documento = {
                docid: datosdoc.docid,
                paginas: datosdoc.docpaginas,
                docarchivo: datosdoc.docarchivo
            };
            await MetodosGenerales.guardarEnSesionInfoReporte(documento, 'documento');

            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
            this.$router.push({ path: asistenciaurl + '/Archivos/EnviarCorreo' });
        },

        async AdjuntarDoc() {
            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
            this.$router.push({ path: asistenciaurl + '/Archivos/AdjuntarDocumento' });
        },

        async obtenerEstadoReporte() {

        },
        async mostrar() {
            if (this.show == true) {
                this.show = false;
            } else {
                this.show = true;
                this.cargando = false;
            }
        },
        async obtenerPermisos() {
            this.aiclave = this.datos.aiclave
            if (this.aiclave == 1 || this.aiclave == 23 || this.aiclave == 24 || this.aiclave == 5 || this.aiclave == 27) {
                let response = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '28,51,343,345,360,383,397');
                if (response.data.length > 0) {
                    response.data.forEach(permiso => {
                        if (permiso.peclave == 51)//Permiso Eliminar
                            this.permisoEliminar = true;
                        if (permiso.peclave == 343)//Permiso calificar
                            this.permisocalificar = true;
                        if (permiso.peclave == 345)//Permiso restablecer
                            this.permisorestablecer = true;
                        if (permiso.peclave == 28)//Permiso restablecer
                            this.permisoennviarcorreo = true;
                        if (permiso.peclave == 360 && !this.statusConclusion)//Permiso para compartir
                            this.permisoCompartir = true;
                        if (permiso.peclave == 383 && !this.statusConclusion)//Permiso para compartir
                            this.permisoReclasificar = true;
                        if (permiso.peclave == 397 && !this.statusConclusion) //Permiso para dividir pdf
                            this.permisoDividirPDF = true;
                    });
                }
                let resp2 = await Archivos.MostarDocNoConformes(this.datos);
                this.mostarBoton = resp2.Column1
            }
        },
        async CalificarDoc(params, datos, fila) {
            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
            this.$router.push({
                path: asistenciaurl + '/Archivos/CalificarDocs', query: {
                    docid: datos.docid,
                    dodescrip: datos.dodescrip,
                    docarchivo: datos.docarchivo
                }
            });
        },
        async DocumentosNC() {
            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
            this.$router.push({ path: asistenciaurl + '/Archivos/DocumentosNoConforme' });

        },
        async GenerarPDF() {
            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
            //this.$router.push({ path: asistenciaurl + '/Archivos/ExportarPDF' });

            let url = this.$router.resolve({ path: asistenciaurl + '/Archivos/ExportarPDF' })
            window.open(url.href, '_blank');


        },
        RestablecerCalif(params, datos, fila) {
            this.$swal({
                title: `El documento: ${datos.dodescrip} ya está  calificado`,
                text: "¿Quiere restablecer la calificación?",
                type: 'warning',
                showCancelButton: true,
                allowOutsideClick: false,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.value) {
                    let respuesta = await Archivos.RestablecerCalificacionDoc(this.datos, datos.docid)
                    if (respuesta.length == 0) {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se restableció la calificación con éxito.',
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            timer: 2500,
                        }).then((result) => {
                            this.reloadTable();
                        })
                    }
                }
            })
        },
        async EliminarArchivo(params, datos, fila) {
            this.$swal({
                position: "center",
                icon: "info",
                text: "¿Está seguro que desea eliminar este archivo?",
                showCancelButton: true,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        title: 'Eliminando archivo, espere, por favor.',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: async () => {
                            this.$swal.showLoading();
                            let resp = await Archivos.EliminarArchivo(this.datos, datos.docid);
                            if (resp.error == false) {
                                var datosReporte = new FormData();
                                datosReporte.append("nrreporte", this.datos.nrreporte);
                                datosReporte.append("svindice", this.datos.svindice);
                                var formData = new FormData();
                                formData.append("lasitio", 'Prusia+');
                                formData.append("lomodulo", "Documentos");
                                formData.append("laaccion", "Eliminó Documento");
                                formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
                                formData.append("lanombre", datos.docarchivo);
                                formData.append("ladestinatario", "");
                                Archivos.AlmacenarVisitas(formData);
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: resp.msg,
                                    showConfirmButton: true,
                                    confirmButtonColor: '#536DFE',
                                    confirmButtonText: 'Aceptar',
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {
                                    this.reloadTable();
                                });

                            } else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'warning',
                                    title: 'Error',
                                    text: resp.msg,
                                    showConfirmButton: false,
                                    timer: 2500
                                });
                            }
                        },
                    });
                }
            });
        },
        async DescargaMasivaZIP() {
            this.$swal({
                title: 'Descargando archivo, espere, por favor.',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.$swal.showLoading();
                    Archivos.DescargaMasivaZIP(this.datos).then(async response => {
                        if (response != null) {
                            const url = window.URL.createObjectURL(new Blob([response]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', this.datos.nrreporte + '-' + this.datos.svindice + '.zip');
                            document.body.appendChild(link);
                            link.click()
                            var formData = new FormData();
                            formData.append("lasitio", 'Prusia+');
                            formData.append("lomodulo", "Documentos");
                            formData.append("laaccion", "Descarga Expediente");
                            formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
                            formData.append("lanombre", this.datos.nrreporte + '-' + this.datos.svindice + '.zip');
                            formData.append("ladestinatario", "");
                            await Archivos.AlmacenarVisitas(formData);
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Correcto',
                                text: 'Archivo descargado correctamente',
                                showConfirmButton: true,
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: 'Ocurrio un error, intentelo más tarde!!',
                                showConfirmButton: false,
                                timer: 2500
                            });
                        }
                    });
                }
            });
        },
        async Compartir() {
            this.share = true;
        },
        seleccionarDocumentos(reporte) {
            this.documentos = reporte;
        },
        SeleccionTablaTipo(tipo) {
            if (tipo == 1) {
                this.apiDT.rows().select();
            } else if (tipo == 2) {
                this.apiDT.rows().deselect();
            } else if (tipo == 3) {
                this.apiDT.rows().every(function () {
                    if (this.nodes().to$().hasClass('selected')) {
                        this.deselect();
                    } else {
                        this.select();
                    }
                });
            }
        },
        async GuardarCompartir() {
            this.errorRadio = this.respuesta == null ? 'Campo requerido' : '';
            if (this.errorRadio == '') {
                this.buttonCompartir = true;
                this.buttonLoading = true;
                let response = await Archivos.CompartirArchivos(this.displayInputs, this.documentos.join(), this.selectedDate.toString());
                if (response == true) {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: "Correcto",
                        text: "El archivo se compartió correctamente.",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        confirmButtonColor: '#536DFE',
                        confirmButtonText: 'Aceptar',
                        timer: 2500,
                    }).then(() => {
                        this.CerrarModal();
                        this.CancelarCompartir();
                    });
                } else {
                    this.$swal({
                        position: "center",
                        icon: "warning",
                        title: "Error",
                        text: "Ocurrió un error, al subir un archivo, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.",
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        timer: 2500,
                    });
                }
                this.buttonCompartir = false;
                this.buttonLoading = false;
            }
        },
        CerrarModal() {
            this.respuesta = null;
            this.selectedDate = '';
            this.share = false;
            this.errorRadio = '';
        },
        Compartir_Archivo(datos) {
            if (datos.Compartio == 1) {
                return `<div style=" display:grid; place-items: center"><div><i aria-hidden="true" class="v-icon notranslate mdi mdi-share-circle" style="color: #4CAF50" title="${datos.EtiquetaCompartir}"></i></div></div>`;
            } else {
                return ``;
            }
        },
        CompartirAlerta() {
            this.$swal({
                position: "center",
                icon: "info",
                title: "Información",
                html: "Solo se mostrarán los documentos calificados como <b>CONFORME</b> Para compartir uno o varios archivos, seleccione las filas correspondientes en la tabla.",
                showConfirmButton: true,
                allowOutsideClick: false,
                confirmButtonColor: '#536DFE',
                confirmButtonText: 'Aceptar',
                //timer: 2500,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.compartirTabla = true;
                }
            });
        },
        CancelarCompartir() {
            this.compartirTabla = false;
            this.documentos = [];
        },
        async DividirPDF(params, datosdoc) {

            let documento = {
                docid: datosdoc.docid,
                paginas: datosdoc.docpaginas,
                dodescrip: datosdoc.dodescrip,
                doclave: datosdoc.doclave
            };
            await MetodosGenerales.guardarEnSesionInfoReporte(documento, 'documento');

            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
            this.$router.push({ path: asistenciaurl + '/Archivos/DividirPDF' });

        }
    }

}

</script>
<!-- <style scoped>
</style> -->
<style>
.iframe-container {
    display: grid;
    justify-content: center;
    align-items: center;
}

.shrinkToFit .fullZoomIn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.v-data-table-header {
    font-weight: bold;
    background-color: success;
}

#titulocard {
    color: white;
}

.tablaDocs div.dt-buttons {
    float: right;
}

.tablaDocs div.dataTables_wrapper div.dataTables_filter {
    text-align: left;
}

.tablaDocs .dataTables_wrapper .dataTables_filter {
    float: left;
    text-align: left;
}

.textButton {
    max-width: -webkit-fill-available !important;
}
</style>